import { APP_STORE_URL } from '../../constants/storeUrls';
import { trackEvent, WEB_STORE_CLICK } from '../../lib/analytics';
import styles from './StoreBadges.module.css';

function AppleIcon() {
  return (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="white">
      <path d="M16.52 12.46c-.03-2.85 2.32-4.22 2.43-4.29-1.32-1.93-3.38-2.2-4.12-2.23-1.75-.18-3.42 1.03-4.31 1.03-.89 0-2.27-1.01-3.73-.98-1.92.03-3.69 1.12-4.68 2.84-2 3.47-.51 8.6 1.43 11.42.95 1.38 2.09 2.92 3.58 2.86 1.43-.06 1.98-.93 3.71-.93 1.73 0 2.22.93 3.74.9 1.55-.03 2.53-1.4 3.47-2.78 1.09-1.6 1.54-3.14 1.57-3.22-.03-.02-3.01-1.16-3.04-4.59l-.05-.03zM13.7 3.87C14.5 2.89 15.04 1.55 14.9.18c-1.17.05-2.59.78-3.43 1.76-.75.87-1.41 2.26-1.23 3.59 1.3.1 2.63-.66 3.46-1.66z" />
    </svg>
  );
}

interface StoreBadgesProps {
  className?: string;
  analyticsLocation?: string;
  /** Side-by-side compact badges (hero mobile). Default stacks on small screens. */
  compact?: boolean;
}

export function StoreBadges({ className = '', analyticsLocation = 'unknown', compact = false }: StoreBadgesProps) {
  function handleStoreClick() {
    void trackEvent(WEB_STORE_CLICK, { platform: 'ios', location: analyticsLocation });
  }

  return (
    <div className={`${styles.badges} ${compact ? styles.compact : ''} ${className}`}>
      <a
        href={APP_STORE_URL}
        className={styles.badge}
        aria-label="Download on the App Store"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleStoreClick}
      >
        <AppleIcon />
        <div className={styles.text}>
          <span className={styles.small}>Download on the</span>
          <span className={styles.large}>App Store</span>
        </div>
      </a>
    </div>
  );
}
